var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer3"},[_c('van-button',{staticClass:"footerbtn",attrs:{"type":"danger"},on:{"click":_vm.subConFirm}},[_vm._v("确认")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }